export const REQUEST_SUBSCRIBE_TO_ICE_BREAKER =
  "REQUEST_SUBSCRIBE_TO_ICE_BREAKER";
export const RECEIVE_ICE_BREAKER_DATA_CHANGE =
  "RECEIVE_ICE_BREAKER_DATA_CHANGE";
export const UNSUBSCRIBE_TO_ICE_BREAKER = "UNSUBSCRIBE_TO_ICE_BREAKER";

export const ICE_BREAKER_COLLECTION = "ice-breakers";
